var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLikeFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.333252 7.07682C0.333252 8.69466 0.760497 10.2954 1.61499 11.8791C2.46948 13.4628 3.68286 15.0046 5.25513 16.5047C6.82739 18.0048 8.68449 19.4385 10.8264 20.8056C10.9479 20.8816 11.0866 20.9519 11.2423 21.0165C11.398 21.081 11.5328 21.1133 11.6467 21.1133C11.7683 21.1133 11.9069 21.081 12.0626 21.0165C12.2183 20.9519 12.3569 20.8816 12.4785 20.8056C14.6204 19.4385 16.4756 18.0048 18.0441 16.5047C19.6125 15.0046 20.824 13.4628 21.6785 11.8791C22.5329 10.2954 22.9602 8.69466 22.9602 7.07682C22.9602 6.06662 22.7988 5.14187 22.476 4.30257C22.1532 3.46327 21.7013 2.736 21.1202 2.12076C20.5391 1.50553 19.8556 1.03082 19.0695 0.696614C18.2833 0.362413 17.4269 0.195312 16.5002 0.195312C15.4445 0.195312 14.5007 0.426976 13.6691 0.890304C12.8373 1.35363 12.1632 1.96886 11.6467 2.73601C11.1378 1.96886 10.4656 1.35363 9.63013 0.890304C8.79462 0.426976 7.84899 0.195312 6.79321 0.195312C5.87416 0.195312 5.02157 0.362413 4.23544 0.696614C3.4493 1.03082 2.7638 1.50553 2.17895 2.12076C1.5941 2.736 1.14027 3.46327 0.817464 4.30257C0.494656 5.14187 0.333252 6.06662 0.333252 7.07682Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeFill);
export default __webpack_public_path__ + "static/media/LikeFill.ebd00d368ef0e890385ff313fcb84d0f.svg";
export { ForwardRef as ReactComponent };